import axios from "axios";

// All KYC verification now goes through the sales backend instead of calling
// Surepass directly. The Surepass token used to live in this file as
// REACT_APP_SUREPASS_TOKEN, which meant it shipped inside the production JS
// bundle and could be read out of devtools by anyone who opened the app.
//
// The backend proxy replays Surepass's status code and response body verbatim,
// so the shapes these functions resolve and reject with are unchanged: callers
// keep reading `res.data.message_code` / `res.data.data` on success and
// `err.response.data.message` on failure. See routes/surepass.js in
// SALES-APP-BACKEND-NODE-API.
//
// getReraDetails was removed here. It was exported but never imported anywhere
// in this app, and it called the legacy /rera/verify-agent endpoint, which the
// backend proxy does not expose — the CP app uses /rera/rera-v2 with a
// different payload and response. RERA numbers are only ever read and displayed
// in this app (KycDocuments, docType "Rera"), never verified.

// The sales backend base URL. The env value normally carries a trailing slash,
// matching the convention used elsewhere for bookings/ and message/ — the trim
// keeps this correct whether or not that slash is present.
const API_ROOT = String(process.env.REACT_APP_PAYMENT_LINK_URL || "").replace(/\/+$/, "");
const SUREPASS_BASE = `${API_ROOT}/api/surepass`;

async function getPAN_cardDetails(panCardNumber) {
    const response = await axios.post(`${SUREPASS_BASE}/pan`, { "id_number": panCardNumber })

    return response;
}
async function getAccountDetails(postBody) {
    const response = await axios.post(`${SUREPASS_BASE}/bank-verification`, postBody)

    return response;
}
async function getAadharCardDetails(aadharNumber) {
    // less_info is still sent explicitly. The backend forwards it only when a
    // caller provides it, so this app keeps the same reduced Aadhaar payload it
    // has always received — the CP app deliberately omits it and gets the full
    // response instead.
    const response = await axios.post(`${SUREPASS_BASE}/aadhaar-validation`, { "id_number": aadharNumber, "less_info": true })

    return response;
}
async function getGSTNumber(panCardNumber) {
    const response = await axios.post(`${SUREPASS_BASE}/gstin-by-pan`, { "id_number": panCardNumber })

    return response;
}
async function getGSTInfo(gstNumber) {
    // filing_status_get is applied by the backend.
    const response = await axios.post(`${SUREPASS_BASE}/gstin`, { "id_number": gstNumber })

    return response;
}

export { getPAN_cardDetails, getAccountDetails, getAadharCardDetails, getGSTNumber, getGSTInfo }
